<template>
  <div class="mm-resp" :class="`mm-resp--${response.kind}`">
    <span class="mm-resp-rail" :style="{ background: accent }"></span>

    <div class="mm-resp-head">
      <span class="mm-resp-badge" :style="{ background: tint, color: accent }">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-compass h-3.5 w-3.5" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/AskPanel.tsx:335:14" data-component-name="Icon" style="color: rgb(0, 172, 238);"><path d="m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z"></path><circle cx="12" cy="12" r="10"></circle></svg>
      </span>
      <span class="mm-resp-eyebrow">{{ eyebrow }}</span>
      <!--span v-if="response.kind === 'status'" class="mm-resp-live">
        <span class="mm-resp-dot" :style="{ background: accent }"></span>
        Updated just now
      </span-->
    </div>

    <p class="mm-resp-text">{{ response.text }}</p>

    <div v-if="actionList.length" class="mm-resp-actions">
      <button
        v-for="(action, index) in actionList"
        :key="index"
        type="button"
        class="mm-resp-action"
        :style="{ background: accent }"
        @click="$emit('action', action)"
      >
        <svg v-if="action.icon === 'MapPin'" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/><circle cx="12" cy="10" r="3"/></svg>
        <svg v-else-if="action.icon === 'Users'" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
        <svg v-else-if="action.icon === 'ClipboardCheck'" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect width="8" height="4" x="8" y="2" rx="1" ry="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><path d="m9 14 2 2 4-4"/></svg>
        <svg v-else-if="action.icon === 'Plus'" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="M12 5v14"/></svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16 3h5v5"/><path d="M8 3H3v5"/><path d="M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3"/><path d="m15 9 6-6"/></svg>
        <span>{{ action.label }}</span>
      </button>
    </div>

    <div class="mm-resp-feedback">
      <button
        v-if="!feedbackSent"
        type="button"
        class="mm-resp-feedback-btn"
        @click="$emit('wrong-answer')"
      >
        Wrong answer
      </button>
      <span v-else class="mm-resp-feedback-done">Thanks — feedback sent</span>
    </div>
  </div>
</template>

<script>

const KIND_EYEBROW = { status: "Answer", howto: "How-to", redirect: "Connect" };

export default {
  name: "AskResponseCard",
  components: {
  },
  props: {
    response: { type: Object, required: true },
    roleAccent: { type: String, default: "#00ACEE" },
    feedbackSent: { type: Boolean, default: false },
  },
  computed: {
    accent() {
      if (this.response.kind === "howto") return "#00ACEE";
      if (this.response.kind === "redirect") return "#795EFF";
      return this.roleAccent || "#00ACEE";
    },
    tint() {
      // 12% alpha of the accent for the icon tile background
      return this.accent + "1F";
    },
    eyebrow() {
      return this.response.eyebrow || KIND_EYEBROW[this.response.kind] || "Answer";
    },
    actionList() {
      if (Array.isArray(this.response.actions) && this.response.actions.length) {
        return this.response.actions;
      }
      return this.response.action ? [this.response.action] : [];
    },
  },
};
</script>

<style scoped>
.mm-resp {
  position: relative;
  border: 1px solid #e4e9ec;
  border-radius: 12px;
  background: #fff;
  padding: 16px 16px 16px 18px;
  overflow: hidden;
}
.mm-resp--redirect {
  background: #f7f6ff;
  border-color: #e5e1ff;
}
.mm-resp-rail {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 3px;
}
.mm-resp-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.mm-resp-badge {
  width: 26px;
  height: 26px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}
.mm-resp-eyebrow {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #6b7785;
}
.mm-resp-live {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  color: #9aa6ae;
}
.mm-resp-dot {
  width: 7px;
  height: 7px;
  border-radius: 9999px;
  animation: mm-pulse 1.8s ease-in-out infinite;
}
.mm-resp-text {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: #002f42;
}
.mm-resp--redirect .mm-resp-text {
  color: #443f6b;
}
.mm-resp-action {
  margin-top: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 14px;
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.15s ease;
}
.mm-resp-actions {
  margin-top: 14px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.mm-resp-action:hover {
  filter: brightness(0.94);
}
.mm-resp-feedback {
  margin-top: 10px;
}
.mm-resp-feedback-btn {
  border: none;
  background: none;
  padding: 0;
  font-size: 12px;
  color: #9aa6ae;
  cursor: pointer;
  text-decoration: underline;
}
.mm-resp-feedback-btn:hover {
  color: #6b7785;
}
.mm-resp-feedback-done {
  font-size: 12px;
  color: #6b7785;
}
@keyframes mm-pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.45;
    transform: scale(0.85);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/manager/AskResponseCard.vue